import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-demo-company',
  templateUrl: './demo-company.component.html',
  styleUrls: ['./demo-company.component.css']
})
export class DemoCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-company.component.ts